export const administrationAccountsSiteLocationRscDetails = {
    template: require('./administration-accounts-site-location-rsc-details.html'),
    controller: 'AdministrationAccountsSiteLocationRscDetailsController'
};
